<lx-form-field
  class="phone-number-field"
  label="{{ label }}"
  i18n-label
  [small]="true"
  [isValid]="validationEnabled ? isValid : null"
  [required]="required"
  [errorMessage]="errorMessage"
  [iconValidation]="true"
>
  <p-dropdown
    class="phone-number-field__phone-code"
    filterBy="name"
    optionLabel="name"
    optionValue="phoneCode"
    [style]="{ width: '100%' }"
    [filter]="true"
    [options]="countries"
    [(ngModel)]="phoneCode"
    (ngModelChange)="onValueChange()"
  >
    <ng-template pTemplate="selectedItem">
      <div *ngIf="phoneCode">{{ phoneCode }}</div>
    </ng-template>
    <ng-template pTemplate="item" let-country>
      <div class="phone-number-field__phone-code__items">
        <div class="phone-number-field__phone-code__items__name">{{ country?.name }}</div>
        <div>{{ country?.phoneCode }}</div>
      </div>
    </ng-template>
  </p-dropdown>
  <p-inputMask
    name="phone"
    class="phone-number-field__number"
    [(ngModel)]="phoneNumber"
    (ngModelChange)="onValueChange()"
    (onBlur)="onInputBlur()"
    mask="99999999999999"
    [slotChar]="''"
    [autoClear]="false"
    [lxPhonePrefixSanitizer]="prefixes"
  />
</lx-form-field>
